import { Injectable } from '@angular/core';
import { StorageEngine } from './storage-engine.interface';

@Injectable({ providedIn: 'root' })
export class ServerStorageService implements StorageEngine {
  private store = new Map<string, string>();

  getItem(key: string): string | null {
    return this.store.has(key) ? this.store.get(key)! : null;
  }

  setItem(key: string, value: string): void {
    this.store.set(key, value);
  }

  removeItem(key: string): void {
    this.store.delete(key);
  }

  clear(): void {
    this.store.clear();
  }
}
